module.exports = __webpack_public_path__ + "static/media/twitter.7681bcec.svg";